import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

export interface GetResolution886AssessmentCategoryResultParams {
	company_id: string;
	organization_id: string;
	report_id: string;
	review_id: string;
	assessment_id?: string;
	activity_id?: string;
}

const Service = Resolution886ReportService.getInstance();

export const useGetResolution886AssessmentCategoryResult = (params: GetResolution886AssessmentCategoryResultParams) => {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.report_id, params.review_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_RESOLUTION_886_CATEGORY_RESULT, params],
		queryFn: async () =>
			Service.getAssessmentCategoryResult({
				...params,
				assessment_id: params.assessment_id || undefined,
				activity_id: params.activity_id || undefined
			}),
		enabled: isEnabled
	});
};
